import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { InvoicesTemplate } from 'components/Templates'

const Invoices: FC = () => {
  return (
    <Layout title={'請求書 | 契約情報'}>
      <InvoicesTemplate />
    </Layout>
  )
}

export default Invoices
